"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appointmentServicesArray = void 0;
exports.appointmentServicesArray = [
    "online",
    "consultorio",
    "bag",
    "chatAtt",
    "quickPrescription",
    "onDemand",
];
